module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-102@3x__7b6db58aa6093db821bac598e6b7b7df.png";